import styled from 'react-emotion';

export const CheckBoxWrapper = styled('div')`
  display: flex;
  margin-bottom: 24px;
  justify-content: center;
`;
